var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ObjectQueryProjection = /** @class */ (function (_super) {
            __extends(ObjectQueryProjection, _super);
            function ObjectQueryProjection() {
                var _this = _super.call(this) || this;
                _this.statusHistoryQueryMap = new models.StatusHistoryQueryMap();
                _this.assignmentQueryMap = new models.AssignmentQueryMap();
                _this.reviewInformationQueryMap = new models.ReviewInformationQueryMap();
                _this.commentInformationQueryMap = new models.CommentInformationQueryMap();
                _this.projectionTypeContext = new models.EnumDropDownContext();
                _this.propertyTypeContext = new models.EnumDropDownContext();
                return _this;
            }
            ObjectQueryProjection.prototype.getExtendedQueryColumn = function () {
                var self = this;
                if (self.propertyType === 8 /* Assignment */) {
                    return Enumerable.from(self.assignmentQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 9 /* ReviewInformation */) {
                    return Enumerable.from(self.reviewInformationQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 6 /* StatusHistory */) {
                    return Enumerable.from(self.statusHistoryQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 12 /* CommentInformation */) {
                    return Enumerable.from(self.commentInformationQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                return null;
            };
            return ObjectQueryProjection;
        }(BaseEntity));
        models.ObjectQueryProjection = ObjectQueryProjection;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
